<template>
    <div>
		<div class="page-btns-box" v-if="$utils.have('/survey/createOrUpdate')" >
		    <el-button type="primary" icon="el-icon-plus" @click="add" size="small">创建问卷</el-button>
		</div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >                
				<el-table-column prop="surveyName" label="主题" min-width="120" show-overflow-tooltip></el-table-column>
				<el-table-column prop="sendCount" label="发放人数"></el-table-column>
				<el-table-column prop="replyCount" label="回复人数"></el-table-column>
				<el-table-column prop="latelySendTime" label="最近发放时间"></el-table-column>				
                <el-table-column fixed="right" width="300" label="操作" >
                   <template slot-scope="scope">
                       <el-button
                           type="text"
                           size="small"
                           icon="el-icon-edit"
                           v-if="$utils.have('/survey/detail')"
                           @click="edit(scope.row.id)"
                           >编辑</el-button
                       >
					   <el-button
					       type="text"
					       size="small"
					       icon="el-icon-document"					      
					       @click="$refs.SendSurvey.show(scope.row.id)"
					       >发放问卷</el-button
					   >
					   <el-button
					       type="text"
					       size="small"
					       icon="el-icon-s-data"
					       @click="datalist(scope.row.id,scope.row.surveyName)"					       
					       >数据统计</el-button
					   >
					   <el-button type="text" size="small" icon="el-icon-link" @click="copy(scope.row.wapLink)">页面地址</el-button>
                   </template>
                </el-table-column>
            </el-table>
        </div>
		<div v-if="data" class="page-pagination-box">
		    <el-pagination
		        background
		        @size-change="handleSizeChange"
		        @current-change="getDataList"
		        :current-page.sync="params.pageNo"
		        :page-sizes="$pageSizes"
		        :page-size.sync="params.pageSize"
		        layout="total, sizes, prev, pager, next"
		        :total="data.totalCount || 0">
		    </el-pagination>
		</div>		
		<SendSurvey ref="SendSurvey"  @update="getDataList()" ></SendSurvey>
		<input class="copyTool" ref="copyTool" :value="copyUrl" />
    </div>
</template>

<script>
import SendSurvey from './components/send-survey';

const defaultQuery = {
    pageNo: 1,
    pageSize: 15,
    
};
export default {
    components:{SendSurvey},
    data(){
        return{
            data: null,
            dataList: null,
			userInfo:null,
            params: {
				...defaultQuery,
				pageNo: parseInt(this.$route.query.pageNo || 1),
				pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
			},
            listLoading: false,
			copyUrl: "",
			copyTimer: null,
			sswap:process.env.VUE_APP_SSWAP_URL,
			
        }
    },
    mounted() {
        this.getDataList();
    },
	computed:{
	   
	},
    methods: {
        //获取列表
		
        getDataList() {
			
            this.listLoading = true;
            this.$request({
                url: "/survey/list",
                method: "POST",
                data: {
                    ...this.params
                },
            })
			.then((res) => {
				const { state, msg, result } = res.data;
				if ( state == 1 && result) {
					this.data = result;
					this.dataList = result.result
					this.dataList.map(item => {
					    item.wapLink = `${this.sswap}/pages/tool/survey/survey?key=${item.id}`
					})
				} else {
					this.$message.error(msg || "请求失败");
				}
			})
			.catch(() => {
				this.$message.error("请求错误");
			})
			.finally(() => {
				this.listLoading = false;
			});
        },
       add(){
           this.$router.push('/operation/survey/add');
		  
		},
		
		edit(id){
		    this.$router.push({
		        path: `/operation/survey/detail/${id}`,
		    });
		},
		datalist(id,name){
			this.$router.push({
			    path: `/operation/survey/datalist/${id}/${name}`,
			});
		},
		
       //选择pageSize
       handleSizeChange(e) {
           this.params.pageNo = 1;
           this.params.pageSize = e;
           this.getDataList();
       },
	   //复制链接
	   copy(url){
	       clearTimeout(this.copyTimer);
	       this.copyUrl = url;
	       this.copyTimer = setTimeout(() => {
	           const e = this.$refs.copyTool;
	           e.select();
	           document.execCommand("Copy"); // 执行浏览器复制命令
	           this.$message.success("已复制成功，可粘贴");
	       },300)
	   },
		//取消订单
		cancel(id){
		    this.$confirm('确定要取消吗?', '提示', {
		        type: 'warning',
		        center: true,
		        closeOnClickModal: false
		    }).then(() => {
		        this.listLoading = true;
		        this.$request({
		            url: '/activiOrder/cancel',
		            method: 'POST',
		            params: {id:id}
		        }).then(res => {
		            const { state, msg } = res.data;
		            if( state == 1 ){
		                this.getDataList();
		            }else{
		                this.$message.error(msg || '请求失败');
		            }
		        }).catch(() => {
		            this.$message.error('请求错误');
		        }).finally(() => {
		            this.listLoading = false;
		        });
		    }).catch(() => {});
		},
    }
}
</script>

<style lang="scss" scoped>
.green{
	color: #1FBB7D;
}
.MR10{
	margin-right: 10px;
	display: inline-block;
	vertical-align: middle;
}
.el-card{
    .el-col{
        line-height: 28px;
    }
}
.copyTool{
    opacity: 0;
    filter: alpha(opacity=0);
    // height: 1px;
}
</style>